import { TodoSettingType } from '../services/TodoSetting';
import TodoFolderView from '../store/schema/TodoFolderView';
import getStore from '../store/store';
import { truthySettingsValue } from '../utils/truthySettingsValue';
import now from 'owa-datetime/lib/userDate/now';
import { getGuid } from 'owa-guid';
import { mutator } from 'satcheljs';
import {
    setSelectedFolderView,
    initializePanelTelemetryData,
    settingsLoaded,
    turnOnFlaggedEmailList,
} from '../actions/todoPanelStoreActions';

export const setSelectedFolderViewMutator = mutator(setSelectedFolderView, actionMessage => {
    getStore().selectedFolderView = actionMessage.todoFolderView;
});

mutator(settingsLoaded, actionMessage => {
    const settings = actionMessage.settings.Value;
    const isFlaggedListEnabled =
        settings.filter(truthySettingsValue(TodoSettingType.ListFlagged_Enabled)).length > 0;
    const onboardingWasDismissed =
        settings.filter(truthySettingsValue(TodoSettingType.ListFlagged_OnboardingLastDismissed))
            .length > 0;
    getStore().showFlaggedEmailToggle = isFlaggedListEnabled && !onboardingWasDismissed;
});

mutator(turnOnFlaggedEmailList, () => {
    // local lie
    getStore().showFlaggedEmailToggle = true;
});

mutator(initializePanelTelemetryData, actionMessage => {
    getStore().panelId = getGuid();
    getStore().panelOpenTime = now();
    getStore().source = actionMessage.source;
    getStore().parentSessionId = actionMessage.parentSessionId;
});

export { TodoFolderView };
